import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Typography from '@lib/components/Typography/Typography';
import { useBreadcrumbContext } from './BreadCrumbsContext';
import styles from './BreadCrumbs.module.scss';

interface Props {
  className?: string;
  resolveLinkPath?: (path: string) => string;
}

function BreadCrumbs({ className, resolveLinkPath }: Props) {
  const { breadcrumbs } = useBreadcrumbContext();
  return (
    <ul
      className={classNames(styles.list, className)}
      data-test-id="layout__breadcrumbs"
    >
      {breadcrumbs.map(({ label, path }, index) => {
        const resolvedPath =
          path && resolveLinkPath ? resolveLinkPath(path) : path;
        return (
          <li key={path ?? `${label}-${index}`} className={styles.listItem}>
            {resolvedPath ? (
              <Link
                to={resolvedPath}
                className={styles.link}
                data-test-id="layout__breadcrumb-link"
              >
                <Typography variant="label" component="span">
                  {label}
                </Typography>
              </Link>
            ) : (
              <Typography variant="label" component="span">
                {label}
              </Typography>
            )}
          </li>
        );
      })}
    </ul>
  );
}
export default BreadCrumbs;
